
import { computed, defineComponent } from 'vue'
import { useStore } from '@/store'

export default defineComponent({
  name: 'EmployeeIndex',
  setup() {
    const store = useStore()
    const cachedViews = computed(() => store.state.tagViews.cachedViews)
    return {
      cachedViews
    }
  }
})
